import React from 'react';
import { ControlCard } from './ControlCard';
import { Tray } from './Tray';

/**
 * The Strings card: one toggle per string, struck through when muted. The tray stretches to
 * one column per string (4, 5 or 6), per rebuild plan open question 8.
 *
 * @param {object} props
 * @param {Array<{label: string, ariaLabel: string}>} props.strings Low to high, same order as `focus`.
 * @param {boolean[]} props.focus Which strings are on.
 * @param {(index: number) => void} props.onToggle
 * @param {'sm'|'md'} [props.size] Card size: 'sm' phone, 'md' desktop.
 */
export function StringsCard({ strings, focus, onToggle, size = 'sm' }) {
  const options = strings.map((s, i) => ({ value: String(i), label: s.label, ariaLabel: s.ariaLabel }));
  const value = options.filter((o) => focus[Number(o.value)]).map((o) => o.value);

  return (
    <ControlCard title="Strings" hint="Tap to mute" size={size}>
      <Tray
        multiple
        ariaLabel="Strings"
        options={options}
        value={value}
        onChange={(v) => onToggle(Number(v))}
        columns={strings.length}
        size="md"
      />
    </ControlCard>
  );
}
